import React from 'react';
// import VideoModal from '../ModalVideo/VideoModal';

const VideoSection1 = () => {
    return (
        <section className="wpo-video-section-4">
            <div className="container">
                <div className="wpo-video-item-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-8 col-12">
                            <div className="video-text-wrap-4">
                                <div className="wpo-viedo-text-4">
                                    <h2>ГАРАНТИЯ НА ВАШ ПРОДУКТ</h2>
                                    <p>Мы гордимся качеством наших услуг и предоставляем гарантии на все наши транспортные и логистические решения.

                                        Наша компания гарантирует сохранность и своевременную доставку вашего груза, а также полное соответствие всех услуг заявленным стандартам.

                                        В случае возникновения непредвиденных ситуаций, мы оперативно решаем все вопросы и предоставляем компенсацию в соответствии с условиями договора.

                                        Наша цель – ваше полное удовлетворение, и мы делаем все возможное, чтобы вы чувствовали уверенность и спокойствие, доверяя нам свои грузы.</p>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-lg-6 col-md-4 col-12">
                            <div className="wpo-video-icon">
                                <VideoModal />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VideoSection1;